"use client";

import styles from "@/styles/modules/components/introduction.module.scss";
import { type Introduction } from "@/types/wordpress-parts";


export default function Introduction({ title, content }: Introduction) {
  if (!title && !content) return null;
  return (
    <section className={styles.introduction}>
      <div className={styles.introductionContainer}>
        {title && <h1 >{title}</h1>}
        {content && (
          <div
            className={styles.freeText}
            dangerouslySetInnerHTML={{ __html: content }}
            data-aos="fade-in" data-aos-delay="200"
          />
        )}
      </div>
    </section>
  );
}
